import usePersistStickyFilters from "./usePersistStickyFilters";
import { persistDocumentLibraryFilterState } from "../utils/documentLibraryFilterPersistence";

/**
 * Writes document-library filter state to sessionStorage whenever it changes.
 * Skips the initial mount so hydration does not immediately overwrite storage.
 */
export default function usePersistDocumentLibraryFilters(screenKey, filterState) {
  usePersistStickyFilters(
    screenKey,
    filterState,
    persistDocumentLibraryFilterState
  );
}
